module.exports = __webpack_public_path__ + "img/gb.bd749493.svg";